import { OCCUPATION_TYPE, TOccupationType } from "@/features/master-data/constants/occupationType";
import { validator } from "@/utils/validator";

/** カテゴリ・職種は名称のみ */
export const masterDataOccupationNameSchema = validator.object().shape({
  name: validator.string().emptyToNull().label("名称").required(),
});

/** 作業は試験名と1号・2号の級が必須。3号は任意（3号が無い作業があるため）。 */
export const masterDataSagyoSchema = validator.object().shape({
  name: validator.string().emptyToNull().label("作業").required(),
  examName: validator.string().emptyToNull().label("試験名").required(),
  level1Name: validator.string().emptyToNull().label("1号修了時の級").required(),
  level2Name: validator.string().emptyToNull().label("2号修了時の級").required(),
  level3Name: validator.string().emptyToNull().label("3号修了時の級").nullable(),
});

/** 階層に応じてスキーマを切り替える */
export const getMasterDataOccupationSchema = (type: TOccupationType) =>
  type === OCCUPATION_TYPE.SAGYO ? masterDataSagyoSchema : masterDataOccupationNameSchema;
